



















import {Component, Prop, Vue} from 'vue-property-decorator'
import axios from 'axios';

@Component
export default class BalancingPaymentForm extends Vue {

    @Prop()
    paymentIntentSecret!: string;

    @Prop()
    stripeSecretKey!: string;

    @Prop()
    csrfToken!: string

    @Prop()
    taxYear!: string;

    private error: string | null = null;
    private cardError: string | null = null;
    private errors: any = {};

    private loading: boolean = false;

    // @ts-ignore
    private stripe = Stripe(this.stripeSecretKey);

    private card!: any;

    private mounted() {

        // Create an instance of Elements.
        const elements = this.stripe.elements();

        // Create an instance of the card Element.
        this.card = elements.create('card', {
            style: {
                base: {
                    color: '#171616',
                    fontFamily: 'Rubik, Helvetica Neue, Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#a0aec0'
                    }
                },
                invalid: {
                    color: '#b14c56',
                    iconColor: '#b14c56'
                }
            },
            iconStyle: 'default',
            hidePostalCode: true
        });

        this.$nextTick(() => {
            // Add an instance of the card Element into the `card-element` <div>.
            this.card.mount('#card-input');

            // Handle real-time validation errors from the card Element.
            this.card.addEventListener('change', (data: any) => {
                this.cardError = data.error?.message || null;
            });
        });

    }

    private clear() {
        this.errors = {};
        this.loading = false;
    }

    private async submit() {
        this.clear();
        this.loading = true;

        // this will handle any SCA
        const stripeResult = await this.stripe.confirmCardPayment(this.paymentIntentSecret, {
            payment_method: {
                card: this.card
            }
        });

        if (stripeResult.error) {
            this.loading = false;
            this.cardError = stripeResult.error.message;
            return;
        }

        // payment has processed successfully, tell server

        axios.post(`/tax-return/${this.taxYear}/balancing-payment-confirm`, {
            _token: this.csrfToken,
            paymentIntent: stripeResult.paymentIntent
        }).then(() => {
            window.location.reload();
        }).catch(error => {
            this.clear();
            this.error = error.response?.data.message || 'Something went wrong when recording your payment. Please contact us as we could have already charged your card.'
            this.errors = error.response?.data.errors || {}
        });
    }
}
